import user from './user';
import hospital from './hospital';
import landing from './landing';
import application from './application';
import file from './file';
import userAccount from './userAccount';
import approval from './approval';
import emailTemplate from './emailTemplate';
import authorizedEmail from './authorizedEmail';
import version from './version';
import system from './system';
import menu from './menu';
import search from './search';
import amendment from './amendment';
import reviewer from './reviewer';
import reviewPanel from './reviewPanel';
import arrangeMeeting from './arrangeMeeting';
import confirmResult from './confirmResult';
import consolidation from './consolidation';
import susarReport from './susarReport';
import postApprovalActivities from './postApprovalActivities';
import miscellaneousReport from './miscellaneousReport';
import progressReport from './progressReport';
import protocolDeviationReport from './protocolDeviationReport';
import localSAEReport from './localSAEReport';
import finalReport from './finalReport';
import comment from './comment'

class APICall {
    user = user;
    menu = menu;
    hospital = hospital;
    landing = landing;
    application = application;
    file = file;
    userAccount = userAccount;
    approval = approval;
    emailTemplate = emailTemplate;
    authorizedEmail = authorizedEmail;
    version = version;
    system = system;
    search = search;
    amendment = amendment;
    reviewer = reviewer;
    reviewPanel = reviewPanel;
    arrangeMeeting = arrangeMeeting;
    confirmResult = confirmResult;
    consolidation = consolidation;
    susarReport = susarReport;
    postApprovalActivities = postApprovalActivities;
    miscellaneousReport = miscellaneousReport;
    progressReport = progressReport;
    protocolDeviationReport = protocolDeviationReport;
    localSAEReport = localSAEReport;
    finalReport = finalReport;
    comment = comment;
}

export default new APICall();
